/** @format */
import {
    MarketCode,
    MarketIso,
    euMarket,
    europeanMarkets,
} from '@toucan/client/global/market';

import { searchClient } from './client';
import { getContentLanguage } from './helpers';
import { getSearchQueryParams } from './search-service';
import { Query, QueryResponse, SearchListingModel } from './types';

export async function getSearchResults<T>(
    search: Query,
    locale: MarketIso,
    marketCode: MarketCode
): Promise<QueryResponse<T>> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    const results = await fetchSearchResults(
        '/product/query',
        search,
        locale,
        marketCode
    );

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return results;
}

export async function getSemanticSearchResults(
    search: Query,
    locale: MarketIso,
    marketCode: MarketCode
): Promise<QueryResponse<SearchListingModel>> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    const results = await fetchSearchResults(
        '/product/semantic-query',
        search,
        locale,
        marketCode
    );

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return results;
}

async function fetchSearchResults(
    path: string,
    search: Query,
    locale: MarketIso,
    marketCode: MarketCode
) {
    // eslint-disable-next-line @mpb-com/mpb/todo-requires-ticket -- Legacy code: do not use as an example.
    // TODO - update when modelOperation is added to search-service
    // overrides the product/model (sets to EU) market for EU markets only.
    if (europeanMarkets.includes(marketCode)) {
        if (search?.filterQuery?.productMarket) {
            search.filterQuery.productMarket = euMarket.code;
        }

        if (search?.filterQuery?.modelMarket) {
            search.filterQuery.modelMarket = euMarket.code;
        }
    }

    const queryParams = getSearchQueryParams(search, marketCode);
    const contentLanguage = getContentLanguage(locale);

    const response = await searchClient.get(`${path}/?${queryParams}`, {
        headers: {
            'Content-Language': contentLanguage,
        },
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return response.data;
}
